import Vue from "vue";
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.MIX_APP_ENV === 'production') {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_JS,
    release: process.env.MIX_BUILD_TIMESTAMP,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // See https://github.com/SamsungInternet/support/issues/56
      'document.getElementsByClassName.ToString',
      'Request failed with status code 401'
    ],
    ignoreUrls: [
      // Google Adsense
      /googlesyndication\.com/i,
      /pagead\/js\/adsbygoogle\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Google DFP
      /doubleclick\.net/i,
      // AMP
      /ampproject\.org/i,
      // Clickio
      /clickiocdn\.com/i,
      // Criteo
      /criteo\.net/i,
      /criteo\.com/i,
    ],
  });
}
